(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setStaggerIndices(parent) {
    var children = parent.querySelectorAll(':scope > [data-erk-reveal]');
    children.forEach(function (child, index) {
      child.style.setProperty('--erk-reveal-index', String(index));
    });
  }

  function revealElement(el) {
    el.classList.add('is-revealed');
  }

  function initScrollReveal(root) {
    if (prefersReducedMotion) {
      root.querySelectorAll('[data-erk-reveal]').forEach(revealElement);
      return;
    }

    root.querySelectorAll('[data-erk-reveal-stagger]').forEach(setStaggerIndices);

    var targets = root.querySelectorAll('[data-erk-reveal]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(revealElement);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealElement(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '-8% 0px', threshold: 0.12 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initHeroReveal(root) {
    var heroes = root.querySelectorAll('[data-erk-hero]');
    heroes.forEach(function (hero) {
      var items = hero.querySelectorAll(':scope > [data-erk-hero-item]');
      items.forEach(function (item, index) {
        item.style.setProperty('--erk-reveal-index', String(index));
      });

      if (prefersReducedMotion) {
        hero.classList.add('is-revealed');
        return;
      }

      requestAnimationFrame(function () {
        hero.classList.add('is-revealed');
      });
    });
  }

  function init(root) {
    root = root || document;
    initScrollReveal(root);
    initHeroReveal(root);
  }

  if (!window.__erkRevealInit) {
    window.__erkRevealInit = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
